function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Zoom_out"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.9 99.2H163v28.3H70.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 263.4l-74.1-74.1c16.1-19.2 24.5-45.1 24.5-75.9 0-36.5-11.9-66.2-34.4-86C179 9.5 150.5 0 116.9 0 83.4 0 54.8 9.5 34.4 27.4 11.9 47.2 0 76.9 0 113.4s11.9 66.2 34.4 86c20.4 17.9 49 27.4 82.5 27.4 27.7 0 51.9-6.5 71-18.8l75.5 75.5 20.1-20.1zM180.7 178c-15.2 13.3-37.2 20.4-63.8 20.4-26.6 0-48.6-7-63.8-20.4-16.4-14.4-24.7-36.1-24.7-64.6s8.3-50.2 24.7-64.6c15.2-13.3 37.2-20.4 63.8-20.4 26.6 0 48.6 7 63.8 20.4 16.4 14.4 24.7 36.1 24.7 64.6 0 28.5-8.3 50.2-24.7 64.6z"
}))));